import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.20_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.101.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/components/report/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/components/status/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/footer/footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/components/actions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/components/navigation/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/header/header.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProviderClient"] */ "/app/src/locales/client.ts");
